import React, { useContext,useEffect,useState } from 'react'
import { keyContext } from '../KeyContext';
import '../../components/css/popup.css';
import cross from '../../images/popup-cross.png'
// import { StartDateCalendar } from './StartDateCalendar';
// import StartClock from './StartClock';
import { DayPicker } from "react-day-picker";
import { format, isSameMonth } from "date-fns";
import moment from 'moment'
import calendar from '../../images/Icon-Calendar.png'
// import close from '../images/close.png'
import da from "date-fns/locale/da";
import small_checkmark from '../../images/small_checkmark.svg'
import small_square from '../../images/small_square.svg'
import Modal from './Modal';
import { useNavigate } from "react-router-dom";


function InternetModal({  shown, close, data, activeColor,  popupbg2, sec1color,sec2color,sec3color}) { 

  const key = sessionStorage.getItem("key");
  const {setWebEditing,setEditedEvId,setShowErrorModal,setErrorNo,setErrorText,setErrorStatus,setErrorType,setWaitingModal,setApiLoader,logOut,eventPushCheck} = useContext(keyContext)
  const [theStartDate, setTheStartDate]   = useState(data.WebreserveInfo?.startDate)
  const [theStartTime, setTheStartTime ] = useState(data.WebreserveInfo?.startTime)
  const [theEndDate,   setTheEndDate] = useState(data.WebreserveInfo?.endDate);
  const [theEndTime,   setTheEndTime] = useState(data.WebreserveInfo?.endTime);
  const [thePickUpDate,   setThePickUpDate] = useState(data.WebreserveInfo?.PickupDate);
  const [thePickUpTime,   setThePickUpTime] = useState(data.WebreserveInfo?.PickupTime);
  
  const [sec1Cal, setSec1Cal] = useState(false);
  const [sec2Cal, setSec2Cal] = useState(false);
  const [sec3Cal, setSec3Cal] = useState(false);

  const [month, setMonth] = useState(); 
  // const [selectedDate, setSelectedDate] = useState(new Date());
  let flag = false // flag determines overlap text when api takes more than 2 seconds to reply
  const navigate = useNavigate();

  const [startDate,setStartDate] = useState(new Date()) 
  
  const [sec1selectedDate, setSec1selectedDate] = useState(new Date())
  const [sec2selectedDate, setSec2selectedDate] = useState(new Date())
  const [sec3selectedDate, setSec3selectedDate] = useState(new Date())
  const [sec1Calendar, setsec1Calendar]         = useState(false);
  const [sec2Calendar, setsec2Calendar]         = useState(false);
  const [sec3Calendar, setsec3Calendar]         = useState(false);
// console.log(sec1selectedDate, sec2selectedDate, sec3selectedDate)
const webResData = data.WebreserveInfo
// console.log(webResData, 'web res data')
const {leftMargin,setEventSaveObj} = useContext(keyContext)
const clientHeight = shown ?  document.getElementById('tes').clientHeight+70 : ''
// const [bgcolor,setbgcolor] = useState()
const [active, setActive]  = useState(theStartDate === 0 && theStartTime === 0 ? true :false);
// const [absolute, setAbsolute] = useState(false);
const [xdag1, setXdag1] = useState(false);
const [xdag2, setXdag2] = useState(false);
const [xdag3, setXdag3] = useState(false)

const [xmin1, setXmin1] = useState(false)
const [xmin2, setXmin2] = useState(false)
const [xmin3, setXmin3 ] = useState(false)

const [chosenTime1,setChosenTime1] = useState(false)

const [efterFors,setEFterFors] = useState(false)
const [chosenTime2,setChosenTime2] = useState(false)

const [forstart,setForstart]  = useState(false)
const [chosenTime3,setChosenTime3] = useState(false)
const [xAfterres, setXafterres] = useState(false)

const [sec1time, setsec1time] = useState('00:00');
const [sec2time, setsec2time] = useState('00:00');
const [sec3time, setsec3time] = useState('00:00');

const [sec1dagb4time,setsec1dagb4time] = useState('00:00')
const [sec2dagb4time,setsec2dagb4time] = useState('00:00')
const [sec3dagb4time,setsec3dagb4time] = useState('00:00')

const [sec1dagb4, setsec1dagb4] = useState('1');
const [sec2dagb4, setsec2dagb4] = useState('1');
const [sec3dagb4, setsec3dagb4] = useState('1');

const [sec1minb4, setsec1minb4] = useState('1');
const [sec2minb4, setsec2minb4] = useState('1');
const [sec3minb4, setsec3minb4] = useState('1');

const [sec3dagefter, setSec3dagefter] = useState('1');

const [autoReservation, setAutoReservation] = useState();
const [autoResClicked, setAutoResClicked] = useState(false);
// handling of autoReservation of en event

// console.log(data, 'data')
 function handleAutoReservation () {
  setAutoResClicked(true)
  setAutoReservation((current) => !current)
  // console.log(autoReservation, 'auto res')
}

useEffect(() => {
//  if(sec1Calendar) {
//   let taskTime = document.querySelector('#sec1tt');
//     taskTime?.addEventListener('input', (e) => {
//     taskTime.blur();
// })
//  }
}, [sec1Calendar])

useEffect(() => {
  if(autoResClicked === true ) { 
   data.AutoDeleteReservation = autoReservation === false ? 0 : 1
   fetchEventSave(data)
  }
}, [autoReservation,data]);

// following 2 function runs when minutes before input is changed in sec1, sec2
function handlesec1minb4 () {
setsec1minb4(document.getElementById('sec1mintt').value)
// setTheStartTime(-document.getElementById('sec1mintt').value)
 const minChanged = -document.getElementById('sec1mintt').value


 // calling fetch event save and saving the new startTime in event save
 data.WebreserveInfo.startTime = minChanged
 data.WebreserveInfo.startDate = 0
 fetchEventSave(data)  // sets startTime of webreservInfo to the new minute

}
// console.log(theStartTime, 'the start time')
function handlesec2minb4 () {
  setsec2minb4(document.getElementById('sec2mintt').value)
  const minChanged = -document.getElementById('sec2mintt').value
//  console.log(minChanged, 'min changed')

 // calling fetch event save and saving the new startTime in event save
 data.WebreserveInfo.endTime = minChanged
 data.WebreserveInfo.endDate = 0
 fetchEventSave(data)  // sets endTime of webreservInfo to the new minute
}
function handlesec3minb4 () {
  setsec3minb4(document.getElementById('sec3mintt').value)
  const minChanged = -document.getElementById('sec3mintt').value
//  console.log(minChanged, 'min changed')

 // calling fetch event save and saving the new pickupTime in event save
 data.WebreserveInfo.PickupTime = minChanged
 data.WebreserveInfo.PickupDate = 0
 fetchEventSave(data)  // sets pickupTime of webreservInfo to the new minute
}

// following 3 functions runs when starttime in valgt tidspunkt is changed in sec1,sec2,sec3
function handlesec1time () { //changes startTime
  setsec1time(document.getElementById('sec1tt').value)
  let time = document.getElementById('sec1tt').value    
  // console.log(time, 'time')
  let time_in_seconds =moment(time,'HH:mm').diff(moment().startOf('day'),'seconds')
  data.WebreserveInfo.startTime = time_in_seconds
  
  fetchEventSave(data)   // sets startTime of webreserveInfo to the new start time in seconds 
  
}
function handlesec2time () {  // changes endTime
  setsec2time(document.getElementById('sec2tt').value)
  let time = document.getElementById('sec2tt').value    
  // console.log(time, 'time')
  let time_in_seconds =moment(time,'HH:mm').diff(moment().startOf('day'),'seconds')
  data.WebreserveInfo.endTime = time_in_seconds

  fetchEventSave(data)   // sets endTime of webreserveInfo to the new end time in seconds
     
}
function handlesec3time () {  // changes pick up time
  setsec3time(document.getElementById('sec3tt').value)
  let time = document.getElementById('sec3tt').value    
  // console.log(time, 'time')
  let time_in_seconds =moment(time,'HH:mm').diff(moment().startOf('day'),'seconds')
  data.WebreserveInfo.PickupTime = time_in_seconds

  fetchEventSave(data)   // sets pick up Time of webreserveInfo to the new pick up time in seconds
}

// following 3 functions runs when time is changed in xdag3 in sec1, sec2, sec3
function handlesec1dagb4time(){
setsec1dagb4time(document.getElementById('sec1dagtt').value)
let time = document.getElementById('sec1dagtt').value    
  //  console.log(time, 'time')
  let time_in_seconds =moment(time,'HH:mm').diff(moment().startOf('day'),'seconds')
  data.WebreserveInfo.startTime = time_in_seconds

  fetchEventSave(data)   // sets startTime of webreserveInfo to the new start time in seconds 
}
function handlesec2dagb4time(){
setsec2dagb4time(document.getElementById('sec2dagtt').value)
let time = document.getElementById('sec2dagtt').value    
  // console.log(time, 'time')
  let time_in_seconds =moment(time,'HH:mm').diff(moment().startOf('day'),'seconds')
  data.WebreserveInfo.endTime = time_in_seconds

  fetchEventSave(data)   // sets endTime of webreserveInfo to the new end time in seconds 
}
function handlesec3dagb4time(){
  setsec3dagb4time(document.getElementById('sec3dagtt').value)
  let time = document.getElementById('sec3dagtt').value    
  // console.log(time, 'time')
  let time_in_seconds =moment(time,'HH:mm').diff(moment().startOf('day'),'seconds')
  data.WebreserveInfo.PickupTime = time_in_seconds

  fetchEventSave(data)   // sets pick upTime of webreserveInfo to the new pick uptime in seconds 
  }
// following 3 functions runs when day before input fields are changed in sec1,sec2.sec3
function handlesec1dagb4 (e) {
// console.log(e.target.value)
setsec1dagb4(e.target.value)

setTheStartDate(-e.target.value)
 
 data.WebreserveInfo.startDate = -e.target.value
 fetchEventSave(data)  // sets start date of webreserveInfo to 0
}
function handlesec2dagb4 (e) {
  // console.log(e.target.value)
  setsec2dagb4(e.target.value)
  data.WebreserveInfo.endDate = -e.target.value
 fetchEventSave(data)  // sets end date of webreserveInfo to 0
  }
function handlesec3dagb4 (e) {
    // console.log(e.target.value)
    setsec3dagb4(e.target.value)
    data.WebreserveInfo.PickupDate = -e.target.value
 fetchEventSave(data)  // sets pickup date of webreserveInfo to 0
    }

    //following function runs when xdag efter reservation input is changed with new
function dagafterRes (e) {
  setSec3dagefter(e.target.value)
  // console.log(e.target.value)
  data.WebreserveInfo.PickupDate = Number(e.target.value)
  fetchEventSave(data) // sets pickupdate to selected input value
}
// console.log(data, 'data')
// following 3 functions runs when start date calendar is clicked in sec1, sec1, sec3
function handlesec1cal () {
  setsec1Calendar((current => !current))
}
function handlesec2cal () {
  setsec2Calendar((current => !current))
}
function handlesec3cal () {
  setsec3Calendar((current => !current))
}
// console.log(sec1selectedDate, 'sec 1 selected date on day click')

// dayclicked function runs when date is selected in calendar in sec1
function dayClickedSec1 () {
  setsec1Calendar(false)
  setSec1Cal(true)
} 
function dayClickedSec2 () {
  setsec2Calendar(false)
  setSec2Cal(true)
}
function dayClickedSec3 () {
  setsec3Calendar(false)
  setSec3Cal(true)
}

useEffect(() => {
  // console.log(sec1selectedDate, sec1Cal, 'inside use effect')
  if(sec1Cal === true ) {
    let dat = moment(sec1selectedDate, 'YYYY-MM-DD');
    let JulianDate = dat.diff(moment('2000-01-01', 'YYYY-MM-DD'), 'days') + 146097  
    data.WebreserveInfo.startDate = JulianDate
    fetchEventSave(data)  // sets startDate of webreserveInfo to the new selected date
  }
  if(sec2Cal === true) {
    // console.log(sec2selectedDate, sec2Cal, 'inside use effect')
   let dat = moment(sec2selectedDate, 'YYYY-MM-DD');
   let JulianDate = dat.diff(moment('2000-01-01', 'YYYY-MM-DD'), 'days') + 146097
  //  console.log(JulianDate) 
   data.WebreserveInfo.endDate = JulianDate
   fetchEventSave(data)  // sets endDate of webreserveInfo to the new selected date
  }
  if(sec3Cal === true ) {
    let dat = moment(sec3selectedDate, 'YYYY-MM-DD');
    let JulianDate = dat.diff(moment('2000-01-01', 'YYYY-MM-DD'), 'days') + 146097  
    data.WebreserveInfo.PickupDate = JulianDate
    fetchEventSave(data)  // sets startDate of webreserveInfo to the new selected date
  }
}, [sec1selectedDate,sec1Cal,sec2selectedDate,sec2Cal,sec3selectedDate,sec3Cal]);



moment.updateLocale("da", {
months:
"Januar_Februar_Marts_April_Maj_Juni_Juli_August_September_Oktober_November_December".split(
"_"
),
});

const disabledDays = [  { from: new Date(2022, 0, 1), to:  moment().subtract(1, 'day').toDate() }  ] ;

// console.log(sec1selectedDate, 'sec1 date')

// setting value from api to dom elements in radio buttons
useEffect(() => {
  // section 1
  if(theStartDate === 0 && theStartTime === 0) {
    setActive(true)
  }
  if(theStartDate > '155000'){
     setChosenTime1(true)
     setSec1selectedDate(moment('2000-01-01', 'YYYY-MM-DD').add(theStartDate  - 146097, 'days')._d)
     setsec1time(moment.utc(theStartTime*1000).format('HH:mm')) // formula for seconds to hh:mm
  }
  if(theStartDate < 0 ){
    setXdag1(true)
  }
  if(theStartTime < 0 && theStartDate === 0){
    setXmin1(true)
  }
  //section 2
  if(theEndDate === 0 && theEndTime === 0){
    setEFterFors(true)
  }
  if(theEndDate > '155000') {
    setChosenTime2(true)
    setSec2selectedDate(moment('2000-01-01', 'YYYY-MM-DD').add(theEndDate  - 146097, 'days')._d)
     setsec2time(moment.utc(theEndTime*1000).format('HH:mm')) // formula for seconds to hh:mm
  }
  if(theEndDate < 0) {
    setXdag2(true)
  }
  if(theEndTime < 0 && theEndDate === 0) {
    setXmin2(true)
  }
  //Section 3
  if(thePickUpDate === 0 && thePickUpTime === 0) { //forestillingsstart true
    setForstart(true)
  }
  if(thePickUpDate  === 0 && thePickUpTime < 0) {  // x tid før fors... true
    setXmin3(true)
  }
  if(thePickUpDate > '155000') {
    setChosenTime3(true)
    setSec3selectedDate(moment('2000-01-01', 'YYYY-MM-DD').add(thePickUpDate  - 146097, 'days')._d)
     setsec3time(moment.utc(thePickUpTime*1000).format('HH:mm')) // formula for seconds to hh:mm
  }
  if(thePickUpDate < 0) {
    setXdag3(true)
  }
  if(thePickUpDate > 0 && thePickUpDate < 1000) {
   setXafterres(true)
  }

},[theStartDate, theStartTime,theEndDate,theEndTime,thePickUpDate,thePickUpTime])
// console.log(sec1minb4)
  //console.log(data)

//---section 1 functions-----
function handleActive () {
  console.log(data)
setActive(true)
setChosenTime1(false)
setXdag1(false)
setXmin1(false)

 setTheStartDate(0)
 setTheStartTime(0)
 data.WebreserveInfo.startDate=0
 data.WebreserveInfo.startTime=0
 fetchEventSave(data)  // sets startTime and  startDate of webreserveIndo to 0
}
// console.log(active,chosenTime1,xdag1,xmin1)
function handleChosenTime1() {
  setChosenTime1(true)
  setActive(false)
  setXdag1(false)
  setXmin1(false)
}
function handleXdag1 () {
  setXdag1(true)
  setActive(false)
  setChosenTime1(false)
  setXmin1(false)

}
function handleXmin1 () {
  setXmin1(true)
  setXdag1(false)
  setActive(false)
  setChosenTime1(false)
 

}

//----section 2 functions----
function handleEfterFors () {
  setEFterFors(true)
  setChosenTime2(false)
  setXdag2(false)
  setXmin2 (false)

  data.WebreserveInfo.endDate = 0
  data.WebreserveInfo.endTime = 0
 fetchEventSave(data)  // sets endTime and  endDate of webreserveIndo to 0

}
function handleChosenTime2 () {
  setEFterFors(false)
  setChosenTime2(true)
  setXdag2(false)
  setXmin2 (false)
}
function handleXdag2 () {
  setEFterFors(false)
  setChosenTime2(false)
  setXdag2(true)
  setXmin2 (false)
}
function handleXmin2 () {
  setEFterFors(false)
  setChosenTime2(false)
  setXdag2(false)
  setXmin2 (true)
}

//---section 3 functions----
function handleChosenTime3 () {
  setChosenTime3(true)
  setForstart(false)
  setXmin3(false)
  setXdag3(false)
  setXafterres(false)
}

function handleForsStart () {
  setChosenTime3(false)
  setForstart(true)
  setXmin3(false)
  setXdag3(false)
  setXafterres(false)

  data.WebreserveInfo.PickupDate = 0
  data.WebreserveInfo.PickupTime = 0

 fetchEventSave(data)  // sets Pick up Time and pick uo Date of webreserveIndo to 0

}
function handleXb4start () {
  setChosenTime3(false)
  setForstart(false)
  setXmin3(true)
  setXdag3(false)
  setXafterres(false)

}
function handleXdagb4 () {
  setChosenTime3(false)
  setForstart(false)
  setXmin3(false)
  setXdag3(true)
  setXafterres(false)

}
function handleXafterres () {
  setChosenTime3(false)
  setForstart(false)
  setXmin3(false)
  setXdag3(false)
  setXafterres(true)

}

// console.log(xmin3)
// event save api call
 function fetchEventSave (event) {
  //  console.log(event, 'the new event to be saved ')
    setWaitingModal(true)
   let taskTime = document.querySelector('#sec1tt');
   let taskTime2 = document.querySelector('#sec2tt');
   let taskTime3 = document.querySelector('#sec3tt');
   
    taskTime?.addEventListener('input', (e) => {
       taskTime.blur();
    })
    taskTime2?.addEventListener('input', (e) => {
       taskTime2.blur();
    })
    taskTime3?.addEventListener('input', (e) => {
       taskTime3.blur();
    }) 
     // above code closes time input
     fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_save` ,{
        method: "POST",
       
       headers: {
        'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        'Content-Type':  'application/x-www-form-urlencoded',
        
       },
     
       body:`Key=${key}&eventdata=${JSON.stringify(event)}`
       
})
     .then(res =>  {
        flag =  true
        if(res.status === 200) {
          return   res.json() 

        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }
       
      })
      .then(result => { 
        console.log(result)
           setWaitingModal(false)
           setApiLoader(false)
           
        if(result.Result === 1) { 
        data= result
        setEventSaveObj(result)
        setWebEditing(true)
        setEditedEvId(event.No)
        setSec1Cal(false)
        setSec2Cal(false)
        setSec3Cal(false)
        }
         else if (result.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }
          else if(result.Result === -1) {
            console.log('call event push check')
            eventPushCheck()
          }
        else {
          setShowErrorModal(true)
          setErrorNo(result.Result)
          setErrorText(result.ErrorDescription)
        }
})  
   setTimeout(function () {
          if(flag === false) {
          
            setApiLoader(true)
            console.log('did not get response in 2 seconds')
            
          } 
         }, 2000)
 }
 const windowHeight = window.innerHeight

return shown ? (
  <Modal open={shown}>

        <div 
        //className="modal-backdrop" 
            // style={{top:'0px',width:'1920px', left: leftMargin, height:clientHeight,border:'1px solid'}}
           
            // onClick={() => {
            //   // close modal when outside of modal is clicked
            //   close();
            // }}
          >
          
            <div
              className="modalcontent" style={{width:'262px',borderRadius:'3px',backgroundColor:'white',position:'absolute',top:windowHeight> 1000 ? '45%' : '69px',left:windowHeight > 1000 ? '50%': '',transform: windowHeight > 1000 ? 'translate(-50%,-50%)':''}}
              onClick={e => {
                // do not close modal if anything inside modal content is clicked
                e.stopPropagation();
              }}
            >
             
              {/* section 1 */}
              <section style={{border:'1px solid #46484c',padding:'10px 12px',borderBottomLeftRadius:'4px',borderBottomRightRadius:'4px',backgroundColor: sec1color}} >
                <button onClick={close} style={{float:'right',marginRight:'-15px',marginTop:'-10px'}}> <img src={cross} alt="" /></button>
                  <p style={{margin:0,color:'#46484c',fontWeight:700,letterSpacing:'0.32px'}}>Internetbestilling</p>  
            <p style={{fontSize:'10px',fontWeight:700,letterSpacing:'0.2px',paddingTop:'7px',height:'15px',color:activeColor}}>Visning på webside</p>

            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}>
               <input onClick={handleActive}  style={{backgroundColor: active === true ? activeColor : ''}} type="radio" name="edit" id="" /> </label>
              <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>Aktiv </p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor=""    style={{border:`1px solid ${activeColor}`}}>
              <input onClick={handleChosenTime1} style={{backgroundColor: chosenTime1 === true ? activeColor : ''}}  type="radio" name="edit" id="" /></label> <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>På et valgt tidspunkt</p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}> 
              <input onClick={handleXdag1} style={{backgroundColor: xdag1 === true ? activeColor : ''}}   type="radio" name="edit" id="" /> </label>
              <p  style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px',}}>X dage før forestillingsstart</p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}>
              <input onClick={handleXmin1} style={{backgroundColor: xmin1 === true ? activeColor : ''}}    type="radio" name="edit" id="" /></label> <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>X minutter før forestillingsstart</p>
            </div>

            {/* ------under menus---- */}          
            {chosenTime1 === true || xdag1 === true || xmin1 === true ? <p className='fors_text'>Forestillingen er aktiv</p> : ''}

              { chosenTime1 === true ?
                  <div className='fors_container'>
                    <div style={{backgroundColor:'#fff',width:'120px',height:'38px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'8.5px 5px'}}>
      <>
      
           <div style={{}}>
               <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold',marginTop:'-4px'}}>Startdato:</p> 
               <p style={{fontSize:'12px', color:'#46484c',marginTop:'-20px'}}>{moment(sec1selectedDate).format('DD/MM/YY')}</p> 
           </div>
           <button style={{height:'29px',width:'30px',borderRadius:'3px',border:`1px solid ${ popupbg2}`}} onClick={handlesec1cal}><img src={calendar} alt="calendar" style={{marginLeft:'-2px',marginTop:'-5px'}}/></button> 

           {sec1Calendar? (
        <div style={{top:'50px'}}
          className={sec1Calendar ? "programCalendar slide-down" : "Calendar slide-up"}
        >
          <figure style={{ textAlign: "right" }}>
            <img src={cross}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={handlesec1cal}
            />
          </figure>
          <div className="weekdays"  >
                            <span className="days">Man</span>
                            <span className="days">Tirs</span>
                            <span className="days">Ons</span>
                            <span className="days">Tors</span>
                            <span className="days">Fre</span>
                            <span className="days">Lør</span>
                            <span className="days">Søn</span>
                          </div>
          <DayPicker
            locale={da} ISOWeek
            mode="single"
              month={month} 
            onMonthChange={setMonth} 
            selected={sec1selectedDate}
            onSelect={setSec1selectedDate}
            onDayClick={dayClickedSec1}
           // disabled={disabledDays}
            showWeekNumber 
            fromYear={2022} toYear={2030}
            captionLayout='dropdown'
            showOutsideDays
            
          />
          
        </div>
      ) : (
        ""
      )}
        
        </>
        </div>

                    <svg style={{marginTop:'5px'}} xmlns="http://www.w3.org/2000/ svg" width="1" height="32"     viewBox="0 0 1 30" fill="none">
                      <rect opacity="0.1" width="1" height="32" fill="#46484C"/>
                    </svg>
                    <div>
                       <div style={{backgroundColor:'#fff',width:'100px',height:'44px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'5px',position:'relative' }}>
                         <div style={{}}>
                              <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold',position:'fixed',zIndex:1,lineHeight:'15px'}}>Starttid</p> 
                              <input type="time"   id='sec1tt' value={sec1time} 
                              onChange={handlesec1time}
                               required=""/>
                              <p style={{height:'30px',width:'30px',borderRadius:'3px',border:`1px solid ${ activeColor}`,right:'9px',top:'8.5px',position:'absolute'}}></p> 
                          </div> 
                      </div>
                    </div>
                  </div>
                :  '' }
              { xdag1 === true ? 
              <div>
                <div style={{marginBottom:'8px'}}>
                 <input type="text" value={sec1dagb4} onChange={(e) => handlesec1dagb4(e)}   style={{height:'23px',width:'28px',border:'none',textAlign:'center',borderRadius:'4px',fontSize:'12px'}}/>
                 <span className='before_efter'>dage før forestillingsstart</span>
                 </div>
                 <div>
                       <div style={{backgroundColor:'#fff',width:'100px',height:'44px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'5px',position:'relative' }}>
                         <div style={{}}>
                              <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold',position:'fixed',zIndex:1,lineHeight:'15px'}}>Starttid:</p> 
                              <input type="time"   id='sec1dagtt' value={sec1dagb4time} onChange={(e) => handlesec1dagb4time(e)} required=""/>
                              <p style={{height:'30px',width:'30px',borderRadius:'3px',border:`1px solid ${ activeColor}`,right:'9px',top:'8.5px',position:'absolute'}}></p> 
                          </div> 
                      </div>
                    </div>
              </div>  : ''}
              { xmin1 === true ?
              <div>
                <div style={{marginBottom:'8px'}}>
                 <input type="text" id='sec1mintt'  value={sec1minb4} onChange={(e) => handlesec1minb4(e)}  style={{height:'23px',width:'28px',border:'none',textAlign:'center',borderRadius:'4px',fontSize:'12px'}}/>
                 <span className='before_efter'>minutter før forestillingsstart</span>
                 </div>
              </div>
                : ''              }

            </section>

                {/* -----'''--section 2------------ */}
            <section style={{borderLeft:'1px solid #46484c',borderRight:'1px solid #46484c',padding:'10px 12px',backgroundColor:sec2color}}> 
            <p style={{fontSize:'10px',fontWeight:700,letterSpacing:'0.2px',paddingTop:'7px',height:'15px',color:activeColor}}>Visning på webside afsluttes</p>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}>
              <input onClick={handleEfterFors}  style={{backgroundColor: efterFors === true ? activeColor : ''}} type="radio" name="edit" id="" />  </label>
              <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>Efter forestillingsdato</p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor=""    style={{border:`1px solid ${activeColor}`}}>
              <input onClick={handleChosenTime2} style={{backgroundColor: chosenTime2 === true ? activeColor : ''}}  type="radio" name="edit" id="" /></label> <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>På et valgt tidspunkt</p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}> 
              <input onClick={handleXdag2} style={{backgroundColor: xdag2 === true ? activeColor : ''}}   type="radio" name="edit" id="" /> </label>
              <p  style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px',}}>X dage før forestillingsstart</p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}>
              <input onClick={handleXmin2} style={{backgroundColor: xmin2 === true ? activeColor : ''}}    type="radio" name="edit" id="" /></label> <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>X minutter før forestillingsstart</p>
            </div>
            {/* ------under menus---- */}
            {chosenTime2 === true || xdag2 === true || xmin2 === true ? <p className='fors_text'>Forestillingen afsluttes</p> : ''}
            
            { chosenTime2 === true ?
                  <div className='fors_container'>
                   <div style={{backgroundColor:'#fff',width:'120px',height:'38px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'8.5px 5px'}}>
      <>
      
           <div style={{}}>
               <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold',marginTop:'-4px'}}>Slutdato:</p> 
               <p style={{fontSize:'12px', color:'#46484c',marginTop:'-20px'}}>{moment(sec2selectedDate).format('DD/MM/YY')}</p> 
           </div>
           <button style={{height:'29px',width:'30px',borderRadius:'3px',border:`1px solid ${ popupbg2}`}} onClick={handlesec2cal}><img src={calendar} alt="calendar" style={{marginLeft:'-2px',marginTop:'-5px'}}/></button> 

           {sec2Calendar? (
        <div style={{top:'50px'}}
          className={sec2Calendar ? "programCalendar slide-down" : "Calendar slide-up"}
        >
          <figure style={{ textAlign: "right" }}>
            <img src={cross}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={handlesec2cal}
            />
          </figure>
          <div className="weekdays"  >
                            <span className="days">Man</span>
                            <span className="days">Tirs</span>
                            <span className="days">Ons</span>
                            <span className="days">Tors</span>
                            <span className="days">Fre</span>
                            <span className="days">Lør</span>
                            <span className="days">Søn</span>
                          </div>
          <DayPicker
            locale={da} ISOWeek
            mode="single"
              month={month} 
            onMonthChange={setMonth} 
            selected={sec2selectedDate}
            onSelect={setSec2selectedDate}
            onDayClick={dayClickedSec2}
         //   disabled={disabledDays}
            showWeekNumber 
            fromYear={2022} toYear={2030}
            captionLayout='dropdown'
            showOutsideDays
            
          />
          
        </div>
      ) : (
        ""
      )}
        
        </>
        </div>
                    <svg style={{marginTop:'5px'}} xmlns="http://www.w3.org/2000/svg" width="1" height="32"     viewBox="0 0 1 30" fill="none">
                      <rect opacity="0.1" width="1" height="32" fill="#46484C"/>
                    </svg>
                    <div>
                       <div style={{backgroundColor:'#fff',width:'100px',height:'44px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'5px',position:'relative' }}>
                         <div style={{}}>
                              <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold',position:'fixed',zIndex:1,lineHeight:'15px'}}>Sluttid:</p> 
                              <input type="time"   id='sec2tt' value={sec2time} onChange={handlesec2time} required=""/>
                              <p style={{height:'30px',width:'30px',borderRadius:'3px',border:`1px solid ${ activeColor}`,right:'9px',top:'8.5px',position:'absolute'}}></p> 
                          </div> 
                      </div>
                    </div>
                  </div>
                :  '' }
              { xdag2 === true ? 
              <div>
                <div style={{marginBottom:'8px'}}>
                 <input type="text" value={sec2dagb4} onChange={(e) => handlesec2dagb4(e)}  style={{height:'23px',width:'28px',border:'none',textAlign:'center',borderRadius:'4px',fontSize:'12px'}} />
                 <span className='before_efter' >dage før forestillingsstart</span>
                 </div>
                 <div>
                       <div style={{backgroundColor:'#fff',width:'100px',height:'44px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'5px',position:'relative' }}>
                         <div style={{}}>
                              <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold',position:'fixed',zIndex:1,lineHeight:'15px'}}>Sluttid:</p> 
                              <input type="time"   id='sec2dagtt' value={sec2dagb4time} onChange={(e) => handlesec2dagb4time(e)} required=""/>
                              <p style={{height:'30px',width:'30px',borderRadius:'3px',border:`1px solid ${ activeColor}`,right:'9px',top:'8.5px',position:'absolute'}}></p> 
                          </div> 
                      </div>
                    </div>
              </div>  : ''}
              { xmin2 === true ?
              <div>
                <div style={{marginBottom:'8px'}}>
                 <input type="text" id='sec2mintt'  value={sec2minb4} onChange={(e) => handlesec2minb4(e)}  style={{height:'23px',width:'28px',border:'none',textAlign:'center',borderRadius:'4px',fontSize:'12px'}}/>
                 <span className='before_efter'>minutter før forestillingsstart</span>
                 </div>
              </div>
                : ''              }



            </section>

            {/* section 3 */}
            
            <section style={{border:'1px solid #46484c',borderBottomLeftRadius:'4px',borderBottomRightRadius:'4px',padding:'10px 12px',backgroundColor:sec3color}}> 
            <p style={{fontSize:'10px',fontWeight:700,letterSpacing:'0.2px',paddingTop:'7px',height:'15px',color:activeColor}}>Reservationsafhentning indtil</p>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}>
              <input onClick={handleForsStart}  style={{backgroundColor: 
                forstart == true ? activeColor : ''}} type="radio" name="edit" id="" /> </label>
              <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>Forestillingsstart</p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor=""    style={{border:`1px solid ${activeColor}`}}>
              <input onClick={handleXb4start} style={{backgroundColor: xmin3 === true ? activeColor : ''}}  type="radio" name="edit" id="" /></label> <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>X tid før forestillingsstart</p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}> 
              <input onClick={handleChosenTime3} style={{backgroundColor: chosenTime3 === true ? activeColor : ''}}   type="radio" name="edit" id="" /> </label>
              <p  style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px',}}>Et valgt tidspunkt</p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}>
              <input onClick={handleXdagb4} style={{backgroundColor: xdag3 === true ? activeColor : ''}}    type="radio" name="edit" id="" /></label> <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>X dage før forestillingsstart</p>
            </div>
            <div style={{display:'flex',height:'18px'}}>
              <label htmlFor="" style={{border:`1px solid ${activeColor}`}}>
              <input onClick={handleXafterres} style={{backgroundColor: xAfterres === true ? activeColor : ''}}    type="radio" name="edit" id="" /></label> <p style={{fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',marginTop:'-2px'}}>X dage efter reservationstidspunkt</p>
            </div>
            {/* ------under menus---- */}
            {chosenTime3 === true || xmin3 === true || xdag3 === true || xAfterres === true  ? <p className='fors_text'>Reservationen skal afhentes senest</p> : ''}
           
            {
              xmin3 === true ? 
              <div style={{marginBottom:'8px'}}>
              <input type="text" id='sec3mintt' placeholder='30' value={sec3minb4} onChange={(e) => handlesec3minb4(e)}  style={{height:'23px',width:'28px',border:'none',textAlign:'center',borderRadius:'4px',fontSize:'12px'}}/>
              <span className='before_efter'>minutter før forestillingsstart</span>
              </div>
              : ''
            }
             { chosenTime3 === true ?
                  <div className='fors_container' style={{marginBottom:'5px'}}>
                   <div style={{backgroundColor:'#fff',width:'120px',height:'38px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'8.5px 5px'}}>
      <>
      
           <div style={{}}>
               <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold',marginTop:'-4px'}}>Dato:</p> 
               <p style={{fontSize:'12px', color:'#46484c',marginTop:'-20px'}}>{moment(sec3selectedDate).format('DD/MM/YY')}</p> 
           </div>
           <button style={{height:'29px',width:'30px',borderRadius:'3px',border:`1px solid ${ popupbg2}`}} onClick={handlesec3cal}><img src={calendar} alt="calendar" style={{marginLeft:'-2px',marginTop:'-5px'}}/></button> 

           {sec3Calendar? (
        <div style={{top:'50px'}}
          className={sec3Calendar ? "programCalendar slide-down" : "Calendar slide-up"}
        >
          <figure style={{ textAlign: "right" }}>
            <img src={cross}
              alt=""
              style={{ cursor: "pointer" }}
              onClick={handlesec3cal}
            />
          </figure>
          <div className="weekdays"  >
                            <span className="days">Man</span>
                            <span className="days">Tirs</span>
                            <span className="days">Ons</span>
                            <span className="days">Tors</span>
                            <span className="days">Fre</span>
                            <span className="days">Lør</span>
                            <span className="days">Søn</span>
                          </div>
          <DayPicker
            locale={da} ISOWeek
            mode="single"
              month={month} 
            onMonthChange={setMonth} 
            selected={sec3selectedDate}
            onSelect={setSec3selectedDate}
            onDayClick={dayClickedSec3}
           // disabled={disabledDays}
            showWeekNumber 
            fromYear={2022} toYear={2030}
            captionLayout='dropdown'
            showOutsideDays
            
          />
          
        </div>
      ) : (
        ""
      )}
        
        </>
        </div>
                    <svg style={{marginTop:'5px'}} xmlns="http://www.w3.org/2000/svg" width="1" height="32"     viewBox="0 0 1 30" fill="none">
                      <rect opacity="0.1" width="1" height="32" fill="#46484C"/>
                    </svg>
                    <div>
                       <div style={{backgroundColor:'#fff',width:'100px',height:'44px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'5px',position:'relative' }}>
                         <div style={{}}>
                              <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold',position:'fixed',zIndex:1,lineHeight:'15px'}}>Tid:</p> 
                              <input type="time"   id='sec3tt' value={sec3time} onChange={handlesec3time} required=""/>
                              <p style={{height:'30px',width:'30px',borderRadius:'3px',border:`1px solid ${activeColor}`,right:'9px',top:'8.5px',position:'absolute'}}></p> 
                          </div> 
                      </div>
                    </div>
                  </div>
                :  '' }
                 { xdag3 === true ?
                 <div>
                  <div style={{marginBottom:'8px'}}>
                  <input type="text" value={sec3dagb4} onChange={(e) => handlesec3dagb4(e)}   style={{height:'23px',width:'28px',border:'none',textAlign:'center',borderRadius:'4px',fontSize:'12px'}}/>
                  <span className='before_efter'>dage før forestillingsstart</span>
                  </div>
                  <div>
                       <div style={{backgroundColor:'#fff',width:'100px',height:'44px',display:'flex', justifyContent:'space-between',borderRadius:'5px',padding:'5px',position:'relative' }}>
                         <div style={{}}>
                              <p style={{fontSize:'12px', color:'#46484c', fontWeight:'bold',position:'fixed',zIndex:1,lineHeight:'15px'}}>Tid:</p> 
                              <input type="time"   id='sec3dagtt' value={sec3dagb4time} onChange={(e) => handlesec3dagb4time(e)} required=""/>
                              <p style={{height:'30px',width:'30px',borderRadius:'3px',border:`1px solid ${ activeColor}`,right:'9px',top:'8.5px',position:'absolute'}}></p> 
                          </div> 
                      </div>
                    </div>
                  </div>
                :  '' }
                { xAfterres === true ?
                  <div style={{marginBottom:'8px'}}>
                  <input type="text" value={sec3dagefter} onChange={(e) => dagafterRes(e)} id='dagafterres'   style={{height:'23px',width:'28px',border:'none',textAlign:'center',borderRadius:'4px',fontSize:'12px'}}/>
                  <span className='before_efter'>dage efter  reservationstidspunkt</span>
                  </div>
                :  '' }
   {chosenTime3 === true || xmin3 === true || xdag3 === true || xAfterres === true  ? 
   <div style={{position:'relative'}}>
   
    <img onClick={handleAutoReservation} src={autoReservation === true || data.AutoDeleteReservation === 1 ? small_checkmark : small_square} alt='checkmark' />
    <span className='before_efter' style={{fontSize:'10px',position:'absolute',top:'6px'}}>Slet reservation når tidspunkt indtræffer</span>
    </div>
   : ''}
            </section>
               
             
              {/* {children} */}
</div>
</div>
</Modal>
    ) : null
}

export default InternetModal